import { styled } from '@mui/system'
import { Tooltip, tooltipClasses } from '@mui/material'

export const StyledTooltip = styled(({ className, children, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }}>
    {children}
  </Tooltip>
))(({ theme }) => ({
  zIndex: 999,
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#fff',
    color: '#000',
    boxShadow: '0 0 15px rgba(0, 0, 0, .8)',
    padding: '17px 22px',
    maxWidth: 'min(360px, calc(100vw - 32px))',
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',

    [theme.breakpoints.down('md')]: {
      padding: '12px 16px',
      boxShadow: '0 4px 15px rgba(0, 0, 0, 0.12)',
      maxWidth: 'calc(100vw - 24px)',
    },
  },
  [`& .${tooltipClasses.arrow}`]: {
    '&::before': {
      backgroundColor: '#fff',
      boxShadow: '0 4px 15px 0 rgba(148, 206, 190, 0.2)',
    },
  },
}))
